import { Injectable, Output, EventEmitter } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { environment } from "../../environments/environment";

import { User } from '../models/user.model';

@Injectable()
export class UserService {
  private users: User[] = [];
  private userApi = environment.apiUrl + '/user';
  private jobTitleApi = environment.apiUrl + '/jobtitile';
  @Output() getUserName: EventEmitter<any> = new EventEmitter();
  @Output() getClientName: EventEmitter<any> = new EventEmitter();
  @Output() getHeaderText: EventEmitter<any> = new EventEmitter();
  @Output() getUrlname: EventEmitter<any> = new EventEmitter();

  constructor(private http: Http) { }

  getUsers(userType: string): Promise<any> {     
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")} );  
    return this.http.get(this.userApi + '?userType=' + userType,{headers: headers}).map(response => {
      return response;
  }).toPromise(); 
  }

  getOneUser(email: string) {     
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")} );  
    return this.http.get(this.userApi + '?email=' + email,{headers: headers});
  }

  getUserByUniqueId(uniqueId: string) {     
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")} );  
    return this.http.get(this.userApi + '?uniqueId=' + uniqueId, {headers: headers});
  }

  getUserById(id: string) {     
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")} );  
    return this.http.get(this.userApi + '/' + id, {headers: headers});
  }

  addUser(user: Object) {
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")});
    return this.http.post(this.userApi, user,{headers: headers});
  }

  updateUserDetails(userId: string, userData) {
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")});
    return this.http.post(this.userApi + '/' + userId, userData ,{headers: headers});
  }

  deleteUser(userId: string){
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")});
    return this.http.delete(this.userApi + '/' + userId ,{headers: headers});
  }

  updateLastSelectedClient(userId: string, clientData) {
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")});
    return this.http.post(this.userApi + '/' + userId + '?updateClient=1', clientData ,{headers: headers});
  }

  generateUniqueId() {
    let timestamp = +new Date;
    let p = (Math.random().toString(16)+timestamp.toString()).substr(2,8);    
    return p.substr(0,4) + p.substr(1,4) + p.substr(2,4) + p.substr(3,4) + p.substr(4,4);
  }

  userNameUpdated() {
    this.getUserName.emit(JSON.parse(localStorage.getItem('user')));
  }

  clientUserNameUpdated() {
    this.getUserName.emit(JSON.parse(localStorage.getItem('loggedInClientUser')));
  }


  clientChanged() {
    this.getClientName.emit(JSON.parse(localStorage.getItem('user')));
  }

  headerTextChanged(headerText) {
    this.getHeaderText.emit(headerText);
  }

  getJobTitles() {
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")});
    return this.http.get(this.jobTitleApi, {headers: headers});
  }

  addJobTitle(jobTitle: Object) {
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")});
    return this.http.post(this.jobTitleApi, jobTitle,{headers: headers});
  }
  urlChanged(urlName) {
    this.getUrlname.emit(urlName);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/user.service.ts